import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import SearchMenu from "../GenericComponents/SearchMenu";
import { RotatingLines } from "react-loader-spinner";
import { colors } from "../../Assets/styles/colors";
import PastMeetingListElement from "./PastMeetingListElement";
import DateRangePicker from "../GenericComponents/DateRangePicker";

import InfiniteScroll from "react-infinite-scroll-component";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import EmptyMeetingList from "../AudioVideoCalls/EmptyMeetingList";
import { useDebouncedValue } from "../../hooks/useDebouncedValue";

const PastMeetingList = ({
  meetings,
  hasMore,
  loadMeetingsHistory,
  handleJoinMeeting,
  selectedMeeting,
  handleSelectMeeting,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [dateRange, setDateRange] = useState({ dateFrom: null, dateTo: null });
  const debouncedSearch = useDebouncedValue(searchInput);
  const { meetingListSpinner } = useGenericComponentsStateService();
  const cursorRef = useRef(null);

  useEffect(() => {
    loadMeetingsHistory({
      reset: true,
      q: debouncedSearch,
      dateFrom: dateRange.dateFrom,
      dateTo: dateRange.dateTo,
    });
  }, [debouncedSearch, dateRange]);

  useEffect(() => {
    cursorRef.current =
      meetings.length > 0 ? meetings[meetings.length - 1].start_at : null;
  }, [meetings]);

  const handleLoadMore = () => {
    loadMeetingsHistory({
      before: cursorRef.current,
      q: debouncedSearch,
      dateFrom: dateRange.dateFrom,
      dateTo: dateRange.dateTo,
    });
  };

  const handleDateRangeChange = (dateFrom, dateTo) => {
    setDateRange({ dateFrom, dateTo });
  };

  return (
    <ChatsList>
      <FiltersRow>
        <SearchMenu value={searchInput} setvalue={setSearchInput} />
        <DateRangePicker onChange={handleDateRangeChange} />
      </FiltersRow>

      {!meetingListSpinner ? (
        meetings.length > 0 ? (
          <Scrollwrapper id={"pastMeetingsList"}>
            <InfiniteScroll
              dataLength={meetings.length}
              next={handleLoadMore}
              hasMore={hasMore}
              scrollableTarget="pastMeetingsList"
              loader={
                <LoaderRow>
                  <RotatingLines
                    strokeColor={colors.purple}
                    strokeWidth={3}
                    animationDuration="0.75"
                    width={24}
                    visible={true}
                  />
                </LoaderRow>
              }
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                width: "100%",
              }}
            >
              {meetings.map((meeting) => (
                <PastMeetingListElement
                  key={meeting.id}
                  data={meeting}
                  selected={selectedMeeting?.id === meeting.id}
                  handleJoinMeeting={handleJoinMeeting}
                  handleSelectMeeting={handleSelectMeeting}
                />
              ))}
            </InfiniteScroll>
          </Scrollwrapper>
        ) : (
          <EmptyMeetingList messageKey="meetings.meeting_history_empty_list" />
        )
      ) : (
        <SpinnerWrapper>
          <RotatingLines
            strokeColor={colors.purple}
            strokeWidth={3}
            animationDuration="0.75"
            width={50}
            visible={true}
          />
        </SpinnerWrapper>
      )}
    </ChatsList>
  );
};

export default PastMeetingList;

const ChatsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 16px 0;
`;
const FiltersRow = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 16px;
`;
const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
const LoaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
`;
const Scrollwrapper = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  position: relative;
`;
